import type { FunctionComponent, PropsWithChildren } from "react"

import dynamic from "next/dynamic"

import { ChatBot } from "@/modules/helpCenter/components/ChatBot"
import { FoLayoutContext } from "@/modules/layouts/contexts/foLayout"
import { useFoLayoutState } from "@/modules/layouts/hooks/useFoLayoutState"
import { NotificationBannerContainer } from "@/modules/notificationBanner/Components/NotificationBannerContainer"
import { ApprovalPage } from "@/modules/termsAndConditions/ApprovalPage/ApprovalPage"
import { TERMS_AND_CONDITIONS_UNLEASH_TOGGLE } from "@/modules/termsAndConditions/flags"
import { useFlag } from "@/modules/unleash/hooks/useFlag"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

export type FoLayoutProps = PropsWithChildren<{
  className?: string
  host: string
}>

const HeaderDynamic = dynamic(() => import("@/modules/headerFooterFO/Header").then(mod => mod.Header))
const FooterDynamic = dynamic(() => import("@/modules/headerFooterFO/Footer/Footer").then(mod => mod.Footer))

export const FoLayout: FunctionComponent<FoLayoutProps> = ({ children, className, host }) => {
  const layoutState = useFoLayoutState(host)
  const isTnCEnabled = useFlag(TERMS_AND_CONDITIONS_UNLEASH_TOGGLE)

  const { isFooterNeeded, isHeaderNeeded } = layoutState

  const { dataCurrentUser } = useCurrentUserFetch()
  const isLogged = !!dataCurrentUser?.isLogged

  if (isLogged && isTnCEnabled && !dataCurrentUser?.attributes.hasAcceptedCurrentTnc) return <ApprovalPage />

  return (
    <FoLayoutContext.Provider value={layoutState}>
      <NotificationBannerContainer />
      {isHeaderNeeded() && <HeaderDynamic />}
      <main className={className}>{children}</main>
      {isFooterNeeded() && <FooterDynamic />}
      <ChatBot />
    </FoLayoutContext.Provider>
  )
}
